import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewControlGeneral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'control_general',
        name: 'Control General',
        component: ViewControlGeneral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
